import React from 'react';
import PropTypes from 'prop-types';
import DateTimeFilter from '../../common/reportTable/filters/DateTimeFilter';
import TextFilter from '../../common/reportTable/filters/TextFilter';
import SelectFilter from '../../common/reportTable/filters/SelectFilter';
import { EventTypes } from '../../../reducers/reports/clientHistory/models';

class FiltersPanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getFilterValue(id) {
    return this.props.filteredBy.find(f => f.id === id);
  }

  handleDelete(deleteFunction) {
    this.props.onFilteredChange(deleteFunction(this.props.filteredBy));
  }

  render() {
    return (
      <div className="filters-panel flex-row flex-wrap" >
        <DateTimeFilter filter={this.getFilterValue("occurredAt")} onDelete={this.handleDelete} readonly label="Od" />
        <SelectFilter filter={this.getFilterValue("type")} onDelete={this.handleDelete} items={EventTypes} readonly label="Zdarzenie" />
        <TextFilter filter={this.getFilterValue("rideId")} onDelete={this.handleDelete} readonly label="Przejazd" />
        <TextFilter filter={this.getFilterValue("bikeNumber")} onDelete={this.handleDelete} readonly label="Rower" />
      </div>
    );
  }
}

FiltersPanel.propTypes = {
  onFilteredChange: PropTypes.func,
  filteredBy: PropTypes.array
};

export default FiltersPanel;
